/**
 * @generated SignedSource<<0940422fd2d31930b5aed279da7fde0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkspaceSignalEditMainDeleteMutation$variables = {
  id: string;
};
export type WorkspaceSignalEditMainDeleteMutation$data = {
  readonly signalWorkspace: {
    readonly delete: {
      readonly id: string;
    };
  };
};
export type WorkspaceSignalEditMainDeleteMutation = {
  response: WorkspaceSignalEditMainDeleteMutation$data;
  variables: WorkspaceSignalEditMainDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "SignalWorkspaceMutation",
    "kind": "LinkedField",
    "name": "signalWorkspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SignalWorkspace",
        "kind": "LinkedField",
        "name": "delete",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceSignalEditMainDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceSignalEditMainDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "93edd45860dd803d021a6c31c2cead32",
    "id": null,
    "metadata": {},
    "name": "WorkspaceSignalEditMainDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceSignalEditMainDeleteMutation(\n  $id: ID!\n) {\n  signalWorkspace(id: $id) {\n    delete {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ea94e813c1c79eb773f095b65ee69495";

export default node;
